import { APIClient, APIClientWithoutToken } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";

const api = new APIClient();
const apiwithouttoken = new APIClientWithoutToken();

const sendContact = (payload: any) => {
  const response: Promise<any> = apiwithouttoken.send(
    url.SEND_CONTACT,
    payload,
  );
  return response;
};

const getContacts = (filters?: object) => {
  return api.get(url.GET_CONTACTS, filters);
};

const inviteContact = (data: object) => {
  return api.create(url.INVITE_CONTACT, data);
};
export { sendContact, getContacts, inviteContact };
